module.exports = __webpack_public_path__ + "static/media/DINOT-Light.1e15a937.woff";